import { EnumOrganizationPermissions } from '@/helpers/enums/permissions.enum';

export const assessments = {
  root: {
    name: 'Assessments',
    path: '/assessments',
    title: 'assessments.survey',
    meta: {
      organizationPermissions: [EnumOrganizationPermissions.Assessment],
      requiresAuth: true,
      hideSideBar: true,
      showOnlyLogo: true,
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Assessments`,
    },
  },
  assessmentsPage: {
    name: 'Assessments Options',
    path: '/assessments/:assessmentId',
    title: 'assessments.assessmentsPage',
    meta: {
      organizationPermissions: [EnumOrganizationPermissions.Assessment],
      requiresAuth: true,
      hideSideBar: true,
    },
  },
};
